import React from 'react';
import Toast from '@applane/react-toast';
import { FormHoc } from '../../../app-components';
import { autoSuggestOptionsInput } from '../../../autoSuggestions';
import {
  blackBookPriceType,
  ROUTES,
  selectDMS,
  selectVMPP,
} from '../../../Lib/constants';
import { invoke } from '../../../AppServices';
import { validateEmail } from '../../../Lib/helpers';
import { setupDealerAccountUri } from '../../../Queries/dealer';

const rooftopTest = (number) => {
  const str = `${number}`;
  const t1 = /^\d+\.?\d*$/.test(str);

  if (str.indexOf('+') !== -1) {
    return 'This must be a number';
  }
  if (str.indexOf('-') !== -1) {
    return 'This must be a number';
  }
  if (str.indexOf('.') !== -1) {
    return 'This must be a number';
  }
  if (!t1) {
    return 'This must be a number';
  }
  return '';
};

const validations = {
  printemailid: ({ data }) => validateEmail(data?.printemailid),
  rooftops: ({ data }) => rooftopTest(data.rooftops),
};

const SetupDealerAccountForm = FormHoc({
  type: 'standard',
  closeView: 0,
  validations,
  uri: setupDealerAccountUri,
  onSubmit: async ({ data, navigation }) => {
    const obj = {};
    obj.dms = data.dms;
    obj.apidms = data.apidms;
    obj.qparamInvCompany = data.qparamInvCompany;
    obj.opentrackDealerData = {
      companyNumber: data.opentrackDealerData?.companyNumber,
      enterpriseCode: data.opentrackDealerData?.enterpriseCode,
    };
    obj.vmpp = data.vmpp;
    obj.apivmpp = data.apivmpp;
    obj.rooftops = Math.floor(data.rooftops);
    obj.printemailid = data.printemailid;
    obj.previouslyOnKyc = 'none';
    obj.setupState = 'Complete';
    obj.blackBookPriceType = data.blackBookPriceType;
    obj.bulkCalls = data.dms === 'Meadowland Systems Inc.' ? 'Complete' : 'Pending';

    const { result } = await invoke({
      id: 'testDealerAPIS',
      paramValue: { data: obj },
    });

    Toast.show(result);

    if (result.type === 'success') {
      await invoke({
        id: 'setupDealerAccount',
        paramValue: {
          data: obj,
          dealerId: navigation?.state?.params?.item?._id,
        },
      });

      Toast.show({
        message: 'Success',
        description: 'Setting Up Account.',
        type: 'success',
        position: 'top',
        direction: 'left',
      });

      navigation.pop();
      navigation.pop();
      navigation.push({
        view: ROUTES.buyPlan.name,
        push: true,
        expanded: true,
        params: { ...navigation?.state?.params },
      });
    }
  },
  mandatory: {
    dms: 1,
    vmpp: 1,
    apidms: ({ data }) => (data?.dms === 'CDK Global' || data?.dms === 'Meadowland Systems Inc.'
      ? 1
      : 0),
    qparamInvCompany: ({ data }) => (data?.dms === 'CDK Global' ? 1 : 0),
    apivmpp: ({ data }) => (data?.vmpp === 'Galves' ? 1 : 0),
    blackBookPriceType: ({ data }) => (data?.vmpp === 'Black Book' ? 1 : 0),
    rooftops: 1,
    rooftopAddress: 1,
  },
  fieldContainer: 'topLabel',
  lg: {
    formGroups: [
      {
        columnsPerRow: 2,
        fieldVariant: 'filled',
        groups: [
          {
            columns: [
              autoSuggestOptionsInput({
                label: 'DMS',
                field: 'dms',
                mandatory: true,
                suggestionField: 'label',
                valueField: 'label',
                options: selectDMS,
                keyField: 'value',
              }),
              {
                type: 'text',
                field: 'apidms',
                label: 'Dealer ID',
                mandatory: true,
                allowWhiteSpaces: false,
                editable: true,
                visible: ({ data = {} }) => {
                  if (
                    data.dms === 'CDK Global'
                    || data.dms === 'Meadowland Systems Inc.' || data.dms === 'Tekion' || data.dms === 'PBS Systems'  
                  ) {
                    return true;
                  }
                  return false;
                },
              },
              {
                type: 'text',
                field: 'qparamInvCompany',
                label: 'Inv Company No.',
                mandatory: true,
                allowWhiteSpaces: false,
                editable: true,
                visible: ({ data = {} }) => {
                  if (data.dms === 'CDK Global') {
                    return true;
                  }
                  return false;
                },
              },
              {
                type: 'text',
                field: 'opentrackDealerData.companyNumber',
                label: 'Company Number',
                mandatory: true,
                allowWhiteSpaces: false,
                editable: true,
                visible: ({ data = {} }) => {
                  if (data.dms === 'Dealertrack DMS') {
                    return true;
                  }
                  return false;
                },
              },
              {
                type: 'text',
                field: 'opentrackDealerData.enterpriseCode',
                label: 'Enterprise Code',
                mandatory: true,
                allowWhiteSpaces: false,
                editable: true,
                visible: ({ data = {} }) => {
                  if (data.dms === 'Dealertrack DMS') {
                    return true;
                  }
                  return false;
                },
              },
              // autoSuggestOptionsInput({
              //   label: 'VMPP',
              //   field: 'vmpp',
              //   mandatory: true,
              //   suggestionField: 'label',
              //   valueField: 'label',
              //   options: selectVMPP,
              //   keyField: 'label',
              // }),
              {
                type: 'text',
                field: 'apivmpp',
                label: 'Enter VMPP API key',
                mandatory: true,
                allowWhiteSpaces: false,
                editable: true,
                visible: ({ data = {} }) => {
                  if (data.vmpp === 'Galves') {
                    return true;
                  }
                  return false;
                },
              },
              {
                type: 'radioGroup',
                field: 'blackBookPriceType',
                label: 'Choose price type for vmpp',
                options: blackBookPriceType,
                mandatory: true,
                visible: ({ data = {} }) => {
                  if (data.vmpp === 'Black Book') {
                    return true;
                  }
                  return false;
                },
              },
              {
                type: 'text',
                field: 'rooftops',
                label: 'Enter number of Rooftops',
                mandatory: true,
                allowWhiteSpaces: false,
                editable: true,
              },

              {
                type: 'text',
                field: 'rooftopAddress',
                label: 'Enter Rooftop Address',
                mandatory: true,
                allowWhiteSpaces: true,
                editable: true,
              },
              {
                type: 'text',
                field: 'printemailid',
                label: 'Print Email Id',
                allowWhiteSpaces: false,
                editable: true,
              },
            ],
          },
        ],
      },
    ],
  },
});

const SetupDealerAccount = (props) => <SetupDealerAccountForm {...props} />;

export default SetupDealerAccount;
